import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  ApplicantFill,
  EOnboardingLogin,
  Login,
  PublicInvoiceView,
  ResumeViewer,
  ResumeViewerApplicant,
  SetPasswordIntermediate
} from "../pages";
import { ProtectedRoute } from "../components";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../redux/slices/auth/authSelectors";
import { usePortalNavigation } from "../hooks/usePortalNavigation";
import { PORTALS } from "./routeConfig";
import WfRoutes from "./WfRoutes";
import AtsRoutes from "./AtsRoutes";
import PtlRoutes from "./PtlRoutes";
import CommonRoutes from "./CommonRoutes";
import BsRoutes from "./BsRoutes";

// Loading component for Suspense fallback
const LoadingComponent = () => (
  <div className="flex items-center justify-center h-screen bg-transparent">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
  </div>
);

const AppRoutes = () => {
  const isLogin = useSelector(selectIsAuthenticated);
  const currentUserDetails = useSelector((state) => state.auth.user) || {};
  const { portalValue, getDefaultRouteForCurrentPortal } = usePortalNavigation(
    isLogin,
    currentUserDetails
  );
  const { moduleAccess = {}, user = {} } = useSelector((state) => state.auth);

  return (
    <Routes>
      {!isLogin && (
        <>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
        </>
      )}
      <Route path="/onboarding-documents/fill" element={<ApplicantFill />} />
      {/* Public Invoice View Route */}
      <Route path="/view/:orgId/:invoiceId" element={<PublicInvoiceView />} />
      <Route path="/wf/onboarding-login" element={<EOnboardingLogin />} />
      {/* protectedRoutes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/login" element={<Navigate to={"/"} />} />
        <Route
          path="/"
          element={<Navigate to={getDefaultRouteForCurrentPortal()} />}
        />
        {/* Common Routes - Available across all portals */}
        {CommonRoutes({ moduleAccess, user })}
        <Route path="/resumeviewer" element={<ResumeViewer />} />
        <Route
          path="/resumeviewerapplicant/:applicantId"
          element={<ResumeViewerApplicant />}
        />
        {/* Conditional Routes based on portal value */}
        {portalValue === PORTALS.WF && WfRoutes()}
        {portalValue === PORTALS.ATS && AtsRoutes({ moduleAccess, user })}
        {portalValue === PORTALS.BS && BsRoutes({ moduleAccess, user })}
        {portalValue === PORTALS.PTL && PtlRoutes()}

        {/* Catch-all route - redirect to appropriate dashboard */}
        <Route
          path="*"
          element={<Navigate to={getDefaultRouteForCurrentPortal()} replace />}
        />
      </Route>
      <Route path="/set-password" element={<SetPasswordIntermediate />} />
    </Routes>
  );
};

export default AppRoutes;

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////
// to Manage the Adjust chunk size limit for this warning via build it it i not working then remove below and use above
////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

// import React, { Suspense, lazy } from "react";
// import { Routes, Route, Navigate } from "react-router-dom";
// // Fix the import path to use the direct file path instead of going through index.js
// const Login = lazy(() => import("../pages/Authentication/Login"));

// import { ProtectedRoute } from "../components";
// import { useSelector } from "react-redux";
// import { selectIsAuthenticated } from "../redux/slices/auth/authSelectors";
// import { usePortalNavigation } from "../hooks/usePortalNavigation";
// import { PORTALS } from "./routeConfig";
// import WfRoutes from "./WfRoutes";
// import AtsRoutes from "./AtsRoutes";
// import PtlRoutes from "./PtlRoutes";
// import CommonRoutes from "./CommonRoutes";

// // Loading component for Suspense fallback
// const LoadingComponent = () => (
//   <div className="flex items-center justify-center h-screen">Loading...</div>
// );

// const AppRoutes = () => {
//   const isLogin = useSelector(selectIsAuthenticated);
//   const currentUserDetails = useSelector((state) => state.auth.user) || {};
//   const { portalValue, getDefaultRouteForCurrentPortal } = usePortalNavigation(
//     isLogin,
//     currentUserDetails
//   );
//   return (
//     <Routes>
//       {!isLogin && (
//         <>
//           <Route
//             path="/"
//             element={
//               <Suspense fallback={<LoadingComponent />}>
//                 <Login />
//               </Suspense>
//             }
//           />
//           <Route
//             path="/login"
//             element={
//               <Suspense fallback={<LoadingComponent />}>
//                 <Login />
//               </Suspense>
//             }
//           />
//         </>
//       )}

//       {/* protectedRoutes */}
//       <Route element={<ProtectedRoute />}>
//         <Route path="/login" element={<Navigate to={"/"} />} />
//         <Route
//           path="/"
//           element={<Navigate to={getDefaultRouteForCurrentPortal()} />}
//         />
//         {/* Common Routes - Available across all portals */}
//         {CommonRoutes()}

//         {/* Conditional Routes based on portal value */}
//         {portalValue === PORTALS.WF && WfRoutes()}
//         {portalValue === PORTALS.ATS && AtsRoutes()}
//         {portalValue === PORTALS.PTL && PtlRoutes()}

//         {/* Catch-all route - redirect to appropriate dashboard */}
//         <Route
//           path="*"
//           element={<Navigate to={getDefaultRouteForCurrentPortal()} replace />}
//         />
//       </Route>
//     </Routes>
//   );
// };

// export default AppRoutes;
